import { useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from "@mui/material";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import ConfigurationMenu from "./ConfigurationMenu";
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ArticleIcon from '@mui/icons-material/Article';
import PeopleIcon from '@mui/icons-material/People';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import PropertyPicturesPage from "./PropertyPictures/PropertyPicturesPage";
import WebsiteContentPage from "./WebsiteContent/WebsiteContentPage";
import UsersPage from "./Users/UsersPage";
import FacilitiesPage from "./Facilities/FacilitiesPage";

export const configurationSubPages = [
    {
        id: 1,
        name: "property-pictures",
        displayName: "Property Pictures",
        icon: <PhotoLibraryIcon />
    }, {
        id: 2,
        name: "website-content",
        displayName: "Website Content",
        icon: <ArticleIcon />
    },
    {
        id: 3,
        name: "users",
        displayName: "Users",
        icon: <PeopleIcon />
    },
    {
        id: 4,
        name: "facilities",
        displayName: "Facilities",
        icon: <SportsTennisIcon />
    }
]

const ConfigurationRouter = (props) => {
    return <Routes>
        <Route exact path="/" element={<Navigate to="property-pictures" />} />
        <Route path=":configurationSubPageName/*" element={<ConfigurationPage {...props} />} />
    </Routes>
}

const ConfigurationPage = (props) => {
    const { configurationSubPageName } = useParams();

    const getSubPage = () => {
        switch (configurationSubPageName) {
            case "property-pictures":
                return PropertyPicturesPage;
            case "website-content":
                return WebsiteContentPage;
            case "users":
                return UsersPage;
            case "facilities":
                return FacilitiesPage;
            default:
                return PropertyPicturesPage;
        }
    }

    const SubPage = getSubPage();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return <Box
        id="configuration"
        sx={{
            display: "flex",
            alignItems: "flex-start",
            flexGrow: 1,
            flexDirection: isMobile ? "column" : "row"
        }}>
        {!isMobile && <ConfigurationMenu value={configurationSubPageName} />}
        <Box id="configurationContent" sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: 'auto', position: 'relative' }}>
            <SubPage />
        </Box>
        {isMobile && <ConfigurationMenu value={configurationSubPageName} mobile />}
    </Box>
}

export default ConfigurationRouter;